/**
 * Widget Library Router
 * All routes are public (no authentication required)
 */

import { createBrowserRouter } from 'react-router-dom';
import { WidgetLayout } from './components/layout';
import { LandingPage } from './pages/landing-page';
import { LibraryPage } from './pages/library-page';
import { DetailPage } from './pages/detail-page';
import { CustomizePage } from './pages/customize-page';

/**
 * Widget Library Routes
 * All routes are public - no authentication required
 * Users create widgets on-the-fly and copy the script - no persistence
 */
export const router = createBrowserRouter([
  {
    element: <WidgetLayout />,
    children: [
      {
        path: '/',
        element: <LandingPage />,
      },
      {
        path: '/templates',
        element: <LibraryPage />,
      },
      {
        path: '/templates/:templateId',
        element: <DetailPage />,
      },
      {
        path: '/customize/:templateId',
        element: <CustomizePage />,
      },
    ],
  },
]);

export default router;
